import React, { Component } from 'react';
import { ACCESS_TOKEN, API_BASE_URL } from "../../constatns";
import GridListTileBar from "@material-ui/core/GridListTileBar";
import IconButton from "@material-ui/core/IconButton";
import GridListTile from "@material-ui/core/GridListTile";
import GridList from "@material-ui/core/GridList";
import no1 from '../../assets/img/no1_100.png';
import no2 from '../../assets/img/no2_100.png';
import no3 from '../../assets/img/no3_100.png';

class TournamentLeaderboard2 extends Component {

  constructor(props) {
    super(props);

    console.log(props)
    this.state = {};
  }

  componentDidMount() {

    let tid = '5e689d8295ee786ff9f66e1d'; // test
    if(this.props.match.path === '/jeju') tid = '5e97c35c51167607c991c9ec';
    if(this.props.match.path === '/blueb') tid = '5ea25210a359970477025f31';
    if(!this.props.match.path) {
      this.props.match.path = '/jeju';
      tid = '5ea25210a359970477025f31';
    }

    fetch(`${API_BASE_URL}/tournament/leaderboardWithCatches?tournamentId=${tid}`, {
      method: 'GET',
    }).then(res => res.text())
      .then(body => {
        let result = JSON.parse(body);
        console.log(result);

        const best = result.map((item, index) => {
          const ribbonColor = index == 0 ? 'ribbon-danger' : index == 1 ? 'ribbon-warning' : 'ribbon-info';
          const award = index == 0 ? <img src={no1} style={{position:'absolute', zIndex: 999, top: '10px', left: '10px'}}/>
            : index == 1 ? <img src={no2} style={{position:'absolute', zIndex: 999, top: '10px', left: '10px'}}/>
            : index == 2 ? <img src={no3} style={{position:'absolute', zIndex: 999, top: '10px', left: '10px'}}/>
            : '';
          // const _style = index == 0 ? {height:'450px', width: '100%'} : {height:'450px'};
          const _style = {height:'250px', width: '100%'};

          const cm = (item.bestCatch[0].length).toFixed(1);

          return (
            <GridListTile key={index} style={_style}>
              {award}
              <img src={item.bestCatch[0].img} alt={item.username} />
              <GridListTileBar
                title={'['+(index+1)+'위] '+item.username}
                subtitle={<span>L : {item.lengthSum}, W : {item.weightSum}, C : {item.count}</span>}
                actionIcon={
                  <IconButton aria-label={`info about ${item.id}`} style={{color: 'rgba(255, 255, 255, 0.54)'}}>
                    {/*{<span>{item.amount} points</span>}*/}
                    {<span>{cm} CM</span>}
                  </IconButton>
                }
              />
            </GridListTile>
          )
        });

        this.setState({best: best});
      });

  }

  render() {

    const handleJoin = (e) => {
      if (localStorage.getItem(ACCESS_TOKEN)) {

      } else {
        alert('로그인 후 참가하실 수 있습니다.');
      }
    };

    function generate(element) {
      return [0, 1, 2].map((value) =>
        React.cloneElement(element, {
          key: value,
        }),
      );
      //accordianVertical
    }

    return (
      <main className={'tournament-page'}>
      <div className={"tournament-detail-banner "+this.props.match.path.replace("/","")} style={{marginBottom: '70px'}}>
        {this.props.match.path === '/jeju' ?
        <div className="title" style={{bottom: '-60px'}}>2020 제주 스마트지깅대회</div>
          : this.props.match.path === '/blueb' ?
            <div className="title" style={{bottom: '-60px'}}>제6회 BLUEB 바낙스 선상낚시대회</div>
            : ""}

      </div>
      <div className="offset-lg-2 col-lg-8" style={{marginBottom: '20px'}}>
        {/*<List>*/}
        {/*  <FlipMove*/}
        {/*    duration={700}*/}
        {/*    delay={10}*/}
        {/*    easing={{ value: '0.42,0.0,0.58,1.0',   label: 'ease' }}*/}
        {/*    staggerDurationBy={15}*/}
        {/*    staggerDelayBy={20}*/}
        {/*    leaveAnimation={'accordianVertical'}*/}
        {/*    enterAnimation={'accordianVertical'}*/}
        {/*  >*/}
        {/*  {this.state.best}*/}
        {/*  </FlipMove>*/}
        {/*</List>*/}
        <GridList cellHeight={236} cols={2} >
          {this.state.best}
        </GridList>
      </div>
      </main>
    );
  }
}

export default TournamentLeaderboard2;
